export default "__VITE_ASSET__53b023d3__"